// extracted by css-extract-rspack-plugin
export default {"text":"cgICw","bouncing":"JoO2V"};